import axios from "../axios";
const END_POINT = "/insurances";

const getInsurances = () => axios.get(`${END_POINT}`);
const searchInsurances = (payload) => axios.post(`${END_POINT}/search`, payload);


export {
  getInsurances,searchInsurances
};
